import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { isEmpty } from 'lodash'

import userInfoStore from '@src/stores'
import logoText from '@assets/logo_text.png'

import Menu from '../menu'
import EditPassword from './components/editPassword'
import AgentInfoModal from './components/AgentInfo'
import LoginStyle from './components/login'
import UserInfo from './components/userInfo'
import styles from './styles.module.less'

export default function Bar() {
  const history = useHistory()
  const [editVisible, setEditVisible] = useState(false)
  const [agentInfoVisible, setAgentInfoVisible] = useState(false)
  const { userInfo, getUserInfo } = userInfoStore.useContainer()

  useEffect(() => {
    getUserInfo()
  }, [getUserInfo])

  return (
    <div className={styles.appContent}>
      <div className={styles.appBar} >
        <div className={styles.appLogo} onClick={() => window.open('https://www.zhi-niao.com/')}>
          <img src={logoText} />
        </div>
        <div className={styles.middleContent}>
          <div>
            <Menu />
          </div>
        </div>
        <div className={styles.rightInfo}>
          <LoginStyle styles={styles} islogin={!!isEmpty(userInfo)} history={history} />
          {
            !isEmpty(userInfo) && (<UserInfo
              styles={styles}
              userName={userInfo?.userName ?? ''}
              setAgentInfoVisible={setAgentInfoVisible}
              setEditVisible={setEditVisible}
            />)
          }
        </div>
        <EditPassword editVisible={editVisible} setEditVisible={setEditVisible} userInfo={userInfo} />
        {
          agentInfoVisible && (
            <AgentInfoModal
              onClose={() => setAgentInfoVisible(false)}
            />
          )
        }
      </div>
    </div>
  )
}

